export default __webpack_public_path__ + "static/media/italygot-screenshot-04.0ecb9c29.png";